import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';

const base = process.env.VUE_APP_SIGNALR_URL
const path = '/message'

export default class SignalR extends HubConnectionBuilder {
  constructor(userId, startImmediately = false) {
    super()
    const url = new URL(path, base)
    url.searchParams.append('userName', userId)

    this.signalr = this
      .withAutomaticReconnect()
      .withUrl(url.toString(), {
        skipNegotiation: true,  // skipNegotiation as we specify WebSockets 
        transport: HttpTransportType.WebSockets  // force WebSocket transport
      })
      .build()

    this.eventFn = []

    if (startImmediately) {
      this.start()
    }
  }

  start = async (cb = () => console.log('connected')) => {
    return this.signalr.start().then(cb)
  }

  stop = async (cb = () => console.log('disconnected')) => {
    return this.signalr.stop().then(cb)
  }

  on = (fcName, cb) => {
    const existFn = this.eventFn.find(fn => fn.fcName === fcName && fn.cb === cb)
    if (existFn) return


    this.signalr.on(fcName, cb)
    this.eventFn.push({ fcName, cb })
  }

  off = (fcName, cb) => {
    const existFnIndex = this.eventFn.findIndex(fn => fn.fcName === fcName && fn.cb === cb)
    if (existFnIndex < 0) return
    this.signalr.off(fcName, cb)
    this.eventFn.splice(existFnIndex, 1)
  }

  onreconnected = (cb = () => console.log('reconnected')) => {
    this.signalr.onreconnected(cb)
  }

  destory = () => {
    for (let fn of this.eventFn) {
      this.off(fn.fcName, fn.cb)
    }

    this.eventFn = []
    return this.stop()
  }

  get ready() {
    return this.signalr.state === 'Connected'
  }
}
